import BaseRepository from 'Domain/Repositories/BaseRepository/BaseRepository';
import { Organizer }   from 'Domain/Models';

const config = {
    model: Organizer,
    baseRoute: '/admin/organisation',
    singular: 'organizer',
    plural: 'organizers',
}

class OrganizerRepository extends BaseRepository<Organizer, typeof config.singular, typeof config.plural> {

  removeEmployeeFromOrganisation({ employeeId, organisationId }: { employeeId: string, organisationId: string }) {
    return this.makeRequest({
      path: `${this.baseRoute}/remove-employee`,
      data: { employeeId, organisationId },
      type: 'POST',
      callback: () => undefined
    });
  }

}

export default new OrganizerRepository(config);
